// let bypassPopup = false;
// document.addEventListener("DOMContentLoaded", function() {
// document.addEventListener('click', function (e) { 
//   const btn = e.target.closest('.product-atc, .product__sticky__bar-add-cart'); 
//     if (!btn) return;
//   e.preventDefault();       
//    // --- Show loader on button ---
//   btn.classList.add('loading');

//      const purchaseOption = document.querySelector('input[name="purchase-option"]:checked')?.value;
//     if (purchaseOption === "onetime" && !bypassPopup) {

//       const popup = document.getElementById("onetime-popup");
//       popup.classList.remove("hidden");
//       document.getElementById("popup-overlay").classList.remove("hidden");
//       btn.classList.remove("disable", "loading");
//       btn.disabled = false;
//       return; // stop normal ATC flow
//     }
//   // Get quantity and variant ID
//   const quantityInput = document.querySelector('.quantity__input');
//   const qty = parseInt(quantityInput.value, 10) || 1;

//   const productInput = document.querySelector('.product-input');
//   const variantId = productInput ? productInput.value : null;

//   if (!variantId) {
//     console.error('No variant ID found.');
//     return;
//   }

//   // Check which purchase option is selected
//   const selectedPurchaseOption = document.querySelector('input[name="purchase-option"]:checked');
//   let sellingPlanId = null;

//   if (selectedPurchaseOption && selectedPurchaseOption.value === 'subscription') {
//     const subscriptionSelect = document.querySelector('#global-subscription-plan');
//     if (subscriptionSelect) {
//       sellingPlanId = subscriptionSelect.value;
//     }
//   }

//   // Prepare data
//   const formData = {
//     items: [
//       {
//         id: variantId,
//         quantity: qty,
//         ...(sellingPlanId && { selling_plan: sellingPlanId })
//       }
//     ]
//   };

//   // Shopify AJAX API
//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(formData)
//   })
//     .then(res => res.json())
//     .then(data => {
//       // If Shopify responds with an error JSON (e.g. sold out)
//       if (data.status && data.message) {
//         // This happens when variant is unavailable
//         alert(data.message || 'This item is sold out.');
//         return; // Do not open cart drawer
//       }

//       if (window.openSidecart) {
//         window.openSidecart();
//         if (window.fetchCart) window.fetchCart();
//       }
//     })
//     .catch(err => {
//       // Network or unexpected error
//       console.error('Error adding to cart:', err);
//       alert('Could not add item to cart. It may be sold out.');
//     })
//      .finally(() => {
//       // --- Hide loader ---
//       btn.classList.remove('loading');
//       bypassPopup = false;
//     });
// });

//   const subBtn = document.getElementById("continue-subscription");
//   const onetimeBtn = document.getElementById("continue-onetime");

//   subBtn.addEventListener("click", function () {
//     const subRadio = document.querySelector('input[name="purchase-option"][value="subscription"]');
//     if (subRadio) subRadio.checked = true;

//     document.getElementById("onetime-popup").classList.add("hidden");
//     document.getElementById("popup-overlay").classList.add("hidden");
//     bypassPopup = true;

//     document.querySelector('.product-atc, .product__sticky__bar-add-cart').click();
//   });

//   onetimeBtn.addEventListener("click", function () {
//     document.getElementById("onetime-popup").classList.add("hidden");
//     document.getElementById("popup-overlay").classList.add("hidden");
//     bypassPopup = true;

//     document.querySelector('.product-atc, .product__sticky__bar-add-cart').click();
//   });

//     const popupClose = document.querySelector('.popup-close');
//   popupClose?.addEventListener('click', function () {
//     document.querySelector('.subscription-popup-outer').classList.add('hidden');
//     document.getElementById("popup-overlay").classList.add("hidden");

//     bypassPopup = true;
//     clickATC();
//   });

// });
// function clickATC() {
//   const mainBtn = document.querySelector('.product-atc');
//   const stickyBtn = document.querySelector('.product__sticky__bar-add-cart');

//   if (mainBtn) {
//     mainBtn.click();
//   } else if (stickyBtn) {
//     stickyBtn.click();
//   } else {
//     console.warn("No ATC buttons found.");
//   }
// }

document.addEventListener('click', function (e) { 
  const btn = e.target.closest('.product-atc, .product__sticky__bar-add-cart'); 
    if (!btn) return;
  e.preventDefault();       
   // --- Show loader on button ---
  btn.classList.add('loading');
  // Get quantity and variant ID
  const quantityInput = document.querySelector('.quantity__input');
  const qty = parseInt(quantityInput.value, 10) || 1;

  const productInput = document.querySelector('.product-input');
  const variantId = productInput ? productInput.value : null;

  if (!variantId) {
    console.error('No variant ID found.');
    return;
  }

  // Check which purchase option is selected
  const selectedPurchaseOption = document.querySelector('input[name="purchase-option"]:checked');
  let sellingPlanId = null;

  if (selectedPurchaseOption && selectedPurchaseOption.value === 'subscription') {
    const subscriptionSelect = document.querySelector('#global-subscription-plan');
    if (subscriptionSelect) {
      sellingPlanId = subscriptionSelect.value;
    }
  }

  // Prepare data
  const formData = {
    items: [
      {
        id: variantId,
        quantity: qty,
        ...(sellingPlanId && { selling_plan: sellingPlanId })
      }
    ]
  };

  // Shopify AJAX API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
    .then(res => res.json())
    .then(data => {
      // If Shopify responds with an error JSON (e.g. sold out)
      if (data.status && data.message) {
        // This happens when variant is unavailable
        alert(data.message || 'This item is sold out.');
        return; // Do not open cart drawer
      }

      if (window.openSidecart) {
        window.openSidecart();
        if (window.fetchCart) window.fetchCart();
      }
    })
    .catch(err => {
      // Network or unexpected error
      console.error('Error adding to cart:', err);
      alert('Could not add item to cart. It may be sold out.');
    })
     .finally(() => {
      // --- Hide loader ---
      btn.classList.remove('loading');
    });
});
// Price update functions code start here

document.addEventListener('DOMContentLoaded', function () {
  const subRadio = document.querySelector('#radio-sub');
  const oneTimeRadio = document.querySelector('#radio-onetime');
  const subPriceEl = document.querySelector('.subscription-original-price');
  const subDiscountEl = document.querySelector('.subscription-discount-price');
  const oneTimePriceEl = document.querySelector('.one-time-discount-price');
  const quantityInput = document.querySelector('.quantity__input');
  const totalPriceEls = document.querySelectorAll('.product-total-price'); 

  // Detect product type (must be in your HTML container)
  const productType = document.querySelector('#subscription-options-block')?.dataset.productType || '';
  // Optional fixed subscription discount set in the PDP section settings (e.g. dryer sheets)
  const customSubDiscount = parseFloat(document.querySelector('#subscription-options-block')?.dataset.subDiscountPercent);

  function parsePrice(str) {
    return parseFloat(str.replace(/[^0-9.]/g, '')) || 0;
  }

  function setTotalPrice(value) {
    totalPriceEls.forEach(el => {
      el.textContent = `$${value}`;
    });
  }

  // --- Calculate subscription total ---
function calculateSubscriptionTotal(qty) {
  const basePrice = parsePrice(subPriceEl.dataset.originalPrice);

  let discountPercent = 0;
  const subpopupdiscount = document.querySelector('.sub-discount');

  if (!isNaN(customSubDiscount)) {
    discountPercent = customSubDiscount;
  }
  else if (productType === '4PackBundle') {
    if (qty === 1) discountPercent = 30;
    // else if (qty === 2) discountPercent = 23.15;
    else discountPercent = 30;
  } 
  else if (productType === '2PackBundle') {
    if (qty === 1) discountPercent = 25;
    else if (qty === 2) discountPercent = 30;
    else discountPercent = 30;
  } 
  else if (productType === '3PackBundle') {
    if (qty === 1) discountPercent = 28;
    else discountPercent = 30;
  }

  const originalTotal = basePrice * qty;
  // Custom % mirrors SKIO, which rounds the per-unit discount down to the cent
  const discountAmount = !isNaN(customSubDiscount)
    ? Math.floor(Math.round(basePrice * 100) * discountPercent / 100) * qty / 100
    : originalTotal * (discountPercent / 100);
  const discountedTotal = originalTotal - discountAmount;
  const subscriptionDiscount = originalTotal - discountedTotal;

  // Retail compare-at price (display only) replaces the one-time price as the struck-through value
  const comparePrice = parsePrice(document.querySelector('#subscription-options-block')?.dataset.comparePrice || '');
  const strikeTotal = comparePrice ? comparePrice * qty : originalTotal;
  if (subPriceEl) subPriceEl.textContent = `$${strikeTotal.toFixed(2)}`;
  if (subDiscountEl) subDiscountEl.textContent = `$${discountedTotal.toFixed(2)}`;

  // Store temporarily so One-Time func can read it later
  window.subscriptionDiscountValue = subscriptionDiscount;

  // *** Popup updated later after one-time discount is calculated ***

  return discountedTotal;
}

  // --- Calculate one-time total ---
  function calculateOneTimeTotal(qty) {
    const basePrice = parsePrice(oneTimePriceEl.dataset.onetimePrice);

    let oneTimeDiscount = 0;
    let discountedTotal = 0;

    const originalTotal = basePrice * qty;

    if (productType === '2PackBundle') {
      if (qty === 1) {
        oneTimeDiscount = 8;
        discountedTotal = originalTotal - oneTimeDiscount;
      } else if (qty >= 2) {
        const bundlePrice = 31.99 * 2; 

        discountedTotal = qty * bundlePrice;

        oneTimeDiscount = originalTotal - discountedTotal;
      }
    }
    else if (productType === '3PackBundle') {
      if (qty === 1) {
        oneTimeDiscount = 19.1952; // exact from sheet
        discountedTotal = originalTotal - oneTimeDiscount;
      } else if (qty >= 2) {
        const unitPrice = 31.992;   // exact Mozi price
        const bundlePrice = unitPrice * 3; // = 95.976

        discountedTotal = qty * bundlePrice;

        oneTimeDiscount = originalTotal - discountedTotal;
      }
    }
    else if (productType === '4PackBundle') {
      if (qty === 1) {
        oneTimeDiscount = 31.99;
        discountedTotal = originalTotal - oneTimeDiscount;
      } else if (qty >= 2) {
        const unitPrice = 31.9925; // precise value
        const bundlePrice = unitPrice * 4; // = 127.97

        discountedTotal = qty * bundlePrice;

        oneTimeDiscount = originalTotal - discountedTotal;
      }
    }

    if (!discountedTotal) {
      discountedTotal = originalTotal;
    }

    if (oneTimePriceEl) {
      oneTimePriceEl.textContent = `$${discountedTotal.toFixed(2)}`;
    }

    const subscriptionDiscount = window.subscriptionDiscountValue || 0;
    const popupValue = oneTimeDiscount - subscriptionDiscount;

    const subpopupdiscount = document.querySelector('.sub-discount');
    if (subpopupdiscount) {
      subpopupdiscount.textContent = `$${Math.abs(popupValue).toFixed(2)}`;
    }

    return discountedTotal;
  }

  // Header price (custom % only): show the per-unit subscribe price struck against the regular price.
  // The section renders the price block twice (mobile + desktop), so update every copy.
  const headerPrices = [...document.querySelectorAll('[id^="price-"] .price')].map(el => ({ el, className: el.className, html: el.innerHTML }));

  function updateHeaderPrice() {
    if (isNaN(customSubDiscount)) return;
    const baseCents = Math.round(parsePrice(subPriceEl.dataset.originalPrice) * 100);
    const subCents = baseCents - Math.floor(baseCents * customSubDiscount / 100);

    headerPrices.forEach(({ el, className, html }) => {
      el.className = className;
      el.innerHTML = html;
      if (!subRadio.checked) return;

      const salePrice = el.querySelector('.price__sale .price-item--sale');
      const comparePrice = el.querySelector('.price__sale s.price-item--regular');
      if (!salePrice || !comparePrice) return;

      el.classList.add('price--on-sale');
      el.classList.remove('price--no-compare');
      salePrice.textContent = `$${(subCents / 100).toFixed(2)}`;
      const retail = parsePrice(document.querySelector('#subscription-options-block')?.dataset.comparePrice || '');
      comparePrice.textContent = `$${(retail || baseCents / 100).toFixed(2)}`;
    });
  }

  function updateTotal() {
    const qty = parseInt(quantityInput.value, 10) || 1;
    updateHeaderPrice();

    const subscriptionTotal = calculateSubscriptionTotal(qty);
    const oneTimeTotal = calculateOneTimeTotal(qty);

    if (subRadio.checked) {
      setTotalPrice(subscriptionTotal.toFixed(2));
    } else if (oneTimeRadio.checked) {
      setTotalPrice(oneTimeTotal.toFixed(2));
    }
  }

  subRadio.addEventListener('change', updateTotal);
  oneTimeRadio.addEventListener('change', updateTotal);
  quantityInput.addEventListener('input', updateTotal);

  document.querySelectorAll('.quantity__button').forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(updateTotal, 50);
    });
  });

  updateTotal();
});

// Price update functions code end here
// Update quantity code in stickybar start  here and vice versa
document.addEventListener("DOMContentLoaded", function() {
  const mainQtyInput = document.querySelector(".product-form__quantity .quantity__input");
  const stickyQtyInput = document.querySelector(".product__sticky__bar-quantity .quantity__input");

  if (mainQtyInput && stickyQtyInput) {
    // --- Sync on page load ---
    stickyQtyInput.value = mainQtyInput.value;

    // --- When main quantity changes → update sticky bar ---
    mainQtyInput.addEventListener("input", syncMainToSticky);
    mainQtyInput.addEventListener("change", syncMainToSticky);

    // --- When sticky quantity changes → update main ---
    stickyQtyInput.addEventListener("input", syncStickyToMain);
    stickyQtyInput.addEventListener("change", syncStickyToMain);

    function syncMainToSticky() {
      stickyQtyInput.value = mainQtyInput.value;
    }

    function syncStickyToMain() {
      mainQtyInput.value = stickyQtyInput.value;
    }

    // --- EXTRA: Ensure plus/minus buttons trigger sync ---
    const observer = new MutationObserver(() => {
      stickyQtyInput.value = mainQtyInput.value;
    });
    observer.observe(mainQtyInput, { attributes: true, attributeFilter: ['value'] });
  }
});

// Update quantity code in stickybar end  here and vice versa

// Subscription sorting code start here
// document.addEventListener('DOMContentLoaded', function () {
//   const select = document.getElementById('global-subscription-plan');
//   const options = Array.from(select.options);

//   // Define your desired order exactly as it appears in the text
//   const order = [
//     "Delivered every 4 weeks",
//     "Delivered every 6 weeks",
//     "Delivered every 2 months",
//     "Delivered every 3 months",
//     "Delivered every 4 months"
//   ];

//   options.sort((a, b) => {
//     const indexA = order.indexOf(a.textContent.trim());
//     const indexB = order.indexOf(b.textContent.trim());

//     // If an option is not in the order array, put it at the end
//     return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
//   });

//   // Remove existing options and append the sorted ones
//   select.innerHTML = '';
//   options.forEach(opt => select.appendChild(opt));
// });
// Subscription sorting code end here

document.addEventListener('DOMContentLoaded', function () {
  // Grab main product block inside .non-subscription
  const mainWrapper = document.querySelector('.non-subscription');
  const mainQty = mainWrapper ? mainWrapper.querySelector('.quantity__input') : null;
  const plusMain = mainWrapper ? mainWrapper.querySelector('button[name="plus"]') : null;
  const minusMain = mainWrapper ? mainWrapper.querySelector('button[name="minus"]') : null;

  // Grab sticky bar quantity input
  const stickyWrapper = document.querySelector('.product__sticky-bar');
  const stickyQty = stickyWrapper ? stickyWrapper.querySelector('.quantity__input') : null;
  const plusSticky = stickyWrapper ? stickyWrapper.querySelector('button[name="plus"]') : null;
  const minusSticky = stickyWrapper ? stickyWrapper.querySelector('button[name="minus"]') : null;

  // Get base price from main plus button or set to 0
  const basePrice = plusMain && plusMain.dataset.price
    ? parseFloat(plusMain.dataset.price.replace(/[^\d.]/g, '')) || 0
    : 0;

  function clampQty(v) { return Math.max(1, parseInt(v, 10) || 1); }

      function syncQtyAndPrice(fromInput) {
            const qty = clampQty(fromInput.value);

            // Sync both inputs
            if (mainQty && mainQty !== fromInput) mainQty.value = qty;
            if (stickyQty && stickyQty !== fromInput) stickyQty.value = qty;

            //  Detect product type
            const productType =
              document.querySelector('#subscription-options-block')?.dataset.productType ||
              document.querySelector('.non-subscription-wrapper')?.dataset.productType ||
              '';

            let total = 0;

            total = (basePrice * qty).toFixed(2);
            //  Update all price displays
            document.querySelectorAll('.product-total-price').forEach(el => {
              el.textContent = `$${total}`;
            });
      }

  // Listen for manual input
  if (mainQty) {
    mainQty.addEventListener('input', () => syncQtyAndPrice(mainQty));
    mainQty.addEventListener('change', () => syncQtyAndPrice(mainQty));
  }
  if (stickyQty) {
    stickyQty.addEventListener('input', () => syncQtyAndPrice(stickyQty));
    stickyQty.addEventListener('change', () => syncQtyAndPrice(stickyQty));
  }

  // Listen for plus/minus (theme updates quantity automatically)
  if (plusMain) plusMain.addEventListener('click', () => setTimeout(() => syncQtyAndPrice(mainQty), 0));
  if (minusMain) minusMain.addEventListener('click', () => setTimeout(() => syncQtyAndPrice(mainQty), 0));
  if (plusSticky) plusSticky.addEventListener('click', () => setTimeout(() => syncQtyAndPrice(stickyQty), 0));
  if (minusSticky) minusSticky.addEventListener('click', () => setTimeout(() => syncQtyAndPrice(stickyQty), 0));

  // Initialize on load
  if (mainQty) syncQtyAndPrice(mainQty);
});

//Upsell addtocart code start here

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.btn-upsell').forEach(function(button) {
    button.addEventListener('click', function() {
       const btn = this;  
        // --- Show loader ---
      btn.classList.add('loading');
      const variantId = this.getAttribute('data-variant-id');

      if (!variantId) {
        console.error("No variant ID found on button.");
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
         if (window.openSidecart) {
        window.openSidecart();
        if (window.fetchCart) window.fetchCart();
         }
      })
      .catch(error => {
        console.error("Error adding to cart:", error);
        //  alert("Error adding to cart: " + error);
      })
         .finally(() => {
      // --- Hide loader ---
      btn.classList.remove('loading');
    });
    });
  });
});

//upsell addtocart code end here
